import apiServices from 'api_services/request-handler';
import { requestHandler } from 'utils/functions';
import { AppDispatch } from '../store';
import { setCustomerDetail, setCustomerLoading, setCustomers, setDeleteLoading } from '../slices/customer-slice';

export const getCustomers = (params: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getCustomers,
        setLoading: setCustomerLoading,
        setData: setCustomers,
        param_data: params,

      }),
    );
  };
};

export const createCustomer = (data: any, onDone: Function) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.createCustomer,
        setLoading: setCustomerLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => onDone()
      }),
    );
  };
};

export const updateCustomer = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.updateCustomer,
        setLoading: setCustomerLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone: (data: any) => {
          onDone();
        },

      }),
    );
  };
};

export const deleteCustomer = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.deleteCustomer,
        setLoading: setDeleteLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone: (data: any) => {
        },
      }),
    );
  };
};


export const getCustomerDetail = (data: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getCustomerDetail,
        setLoading: setCustomerLoading,
        param_data: data,
        setData: setCustomerDetail
      }),
    );
  };
};
